import { SkeletonLine, SkeletonStack, WidgetCard } from "@health/ui";

/**
 * Loading skeleton mirroring IntakeSummary — header row, then a few
 * sections, each with an uppercase section label and a list of question
 * rows showing label + truncated answer.
 */
const SECTIONS: Array<Array<{ label: "sm" | "md"; value: "md" | "lg" | "sm" }>> = [
  [
    { label: "sm", value: "md" },
    { label: "md", value: "lg" },
  ],
  [
    { label: "sm", value: "sm" },
    { label: "md", value: "md" },
    { label: "sm", value: "lg" },
  ],
];

function Row({ label, value }: { label: "sm" | "md"; value: "md" | "lg" | "sm" }) {
  return (
    <div className="space-y-1 px-2.5 py-2">
      <SkeletonLine $size="caption" $width={label} />
      <SkeletonLine $size="text" $width={value} />
    </div>
  );
}

export function IntakeSummarySkeleton() {
  return (
    <WidgetCard $padding="md" className="w-full">
      <SkeletonStack>
        <div className="flex items-center justify-between">
          <SkeletonLine $size="title" $width="sm" />
          <SkeletonLine $size="caption" $width="xs" />
        </div>
        {SECTIONS.map((rows, i) => (
          <div key={i} className="space-y-2">
            <SkeletonLine $size="caption" $width="xs" />
            <div>
              {rows.map((r, j) => (
                <Row key={j} label={r.label} value={r.value} />
              ))}
            </div>
          </div>
        ))}
      </SkeletonStack>
    </WidgetCard>
  );
}
